import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils";
const FormFieldContext = React.createContext({
    hasError: false,
    id: "",
});
function FormField({ error, fieldId, className, children, ...props }) {
    const generatedId = React.useId();
    const id = fieldId ?? generatedId;
    return (_jsx(FormFieldContext.Provider, { value: { hasError: !!error, id }, children: _jsxs("div", { className: cn("space-y-1.5", className), "data-field-id": id, ...props, children: [children, error && (_jsx("p", { role: "alert", className: "flex items-center gap-1 text-sm text-destructive", children: error }))] }) }));
}
function FormFieldLabel({ className, required, children, htmlFor, ...props }) {
    const { id } = React.useContext(FormFieldContext);
    return (_jsxs("label", { htmlFor: htmlFor ?? id, className: cn("text-sm font-medium leading-none", "peer-disabled:cursor-not-allowed peer-disabled:opacity-70", className), ...props, children: [children, required && (_jsx("span", { className: "ml-0.5 text-destructive", "aria-hidden": "true", children: "*" }))] }));
}
// ── Helper text ───────────────────────────────────
function FormFieldHelper({ className, children, ...props }) {
    return (_jsx("p", { className: cn("text-sm text-muted-foreground", className), ...props, children: children }));
}
// ── Input wrapper (applies error border to child) ─
function FormFieldInput({ className, children, ...props }) {
    const { hasError } = React.useContext(FormFieldContext);
    return (_jsx("div", { className: cn("[&>input]:border-input [&>textarea]:border-input [&>select]:border-input", hasError && "[&>input]:border-destructive [&>textarea]:border-destructive [&>select]:border-destructive", className), ...props, children: children }));
}
// ── Error message (standalone, not auto-rendered) ─
function FormFieldError({ className, children, ...props }) {
    return (_jsx("p", { role: "alert", className: cn("flex items-center gap-1 text-sm text-destructive", className), ...props, children: children }));
}
export { FormField, FormFieldLabel, FormFieldHelper, FormFieldInput, FormFieldError, };
//# sourceMappingURL=form-field.js.map